<template>
    <div class="sms-check-block">
        <div class="sms-check-block__wrapper">
            <p class="sms-check-block__text sms-check-block__text_note">Сообщение с кодом отправлено на номер</p>
            <p class="sms-check-block__text sms-check-block__text_phone">{{ tel }}</p>
            <form class="sms-check-block__form">
                <ImaskInput
                    v-model="code"
                    :mask="mask.mask"
                    class="sms-check-block__input"
                    placeholder="Код из sms"
                />
                <p
                    v-if="errorMessage"
                    class="sms-check-block__retry-enter-message"
                >
                    {{ errorMessage }}
                </p>
                 <p
                    v-if="secondsUntilNextCodeRequestAvailable > 0"
                    class="sms-check-block__resend-message"
                >
                    Отправить повторно через {{ secondsUntilNextCodeRequestAvailable | countdownTimer }}
                </p>
                <a
                    v-if="secondsUntilNextCodeRequestAvailable <= 0"
                    class="sms-check-block__resend"
                    @click="resend"
                >
                    Отправить повторно
                </a>
                <RsvButton
                    class="sms-check-block__submit-button"
                    text="Подтвердить"
                    weight="600"
                    color="primary"
                    @click.prevent="submit"
                />
            </form>
            <div class="sms-check-block__footer">
                <div
                    v-if="wrongCodeMsgOpened"
                    class="sms-check-block__wrong-code-msg">
                    <p class="sms-check-block__wrong-code-text">
                        Проверьте правильность написания номера
                        или попробуйте перезагрузить телефон
                    </p>
                    <RsvButton
                        class="sms-check-block__wrong-code-btn"
                        text="закрыть"
                        color="transparent"
                        @click="toggleWrongMsg"
                    />
                </div>
                <RsvButton
                    noindent
                    text="Не получили код проверки?"
                    color="transparent"
                    class="sms-check-block__not-get-code"
                    @click="toggleWrongMsg"
                />
                <RsvButton
                    noindent
                    text="Отменить"
                    color="transparent"
                    class="sms-check-block__cancel"
                    @click="$emit('cancel')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { IMaskComponent } from 'vue-imask';
import RsvButton from '../RsvButton/RsvButton';

export default {
    name: 'SmsCheckBlock',
    props: {
        tel: {
            type: String,
            required: true,
        },
        errorMessage: {
            type: String,
        },
        secondsUntilNextCodeRequestAvailable: {
            type: Number,
            required: true,
        },
    },
    components: {
        RsvButton,
        ImaskInput: IMaskComponent,
    },
    data: () => ({
        code: '',
        timer: null,
        wrongCodeMsgOpened: false,
        mask: {
            mask: '0000',
            lazy: true,
        },
    }),
    methods: {
        toggleWrongMsg() {
            this.wrongCodeMsgOpened =! this.wrongCodeMsgOpened;
        },
        resend() {
            this.$emit('nextCodeRequest');
        },
        submit() {
            this.$emit('submit', this.code);
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "~@/styles/rem";

    .sms-check-block {

        $blue: #4663AB;
        border-radius: mrem(4);
        margin: mrem(15) 0;
        width: 100%;
        font-size: mrem(16);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: mrem(45);
        background: #E2E2E2;

        @include on-desktop {
            border-radius: rem(4);
            margin: rem(15) 0;
            width: rem(470);
            padding: rem(45);
            font-size: rem(16);
        }

        &__wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: mrem(416);
            margin-bottom: 0;

            @include on-desktop {
                margin-bottom: 0;
            }
        }

        &__text {
            margin: 0;

            &_note {
                margin-bottom: mrem(11);

                @include on-desktop {
                    margin-bottom: rem(11);
                }
            }

            &_phone {
                font-weight: 600;
                margin-bottom: mrem(11);

                @include on-desktop {
                    margin-bottom: rem(11);
                }
            }
        }

        &__form {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: mrem(40);

            @include on-desktop {
                margin-bottom: rem(40);
            }
        }

        &__input {
            border: none;
            height: mrem(48);
            text-align: center;
            font-size: mrem(16);
            padding: mrem(12) mrem(16);
            border-radius: mrem(4);
            margin-bottom: mrem(11);

            @include on-desktop {
                width: rem(317);
                padding: rem(12) rem(16);
                height: rem(48);
                font-size: rem(16);
                border-radius: rem(4);
                margin-bottom: rem(11);
            }
        }

        &__resend-message {
            color: #98A0A9;
            margin: 0 0 mrem(6) 0;

            @include on-desktop {
                margin: 0 0 rem(6) 0;
            }
        }

        &__retry-enter-message {
            position: relative;
            padding-left: 0;
            margin: 0 0 mrem(11) 0;
            padding-left: rem(24);
            font-size: mrem(14);
            margin-left: mrem(16);

            @include on-desktop {
                margin: 0 0 rem(11) 0;
                padding-left: rem(24);
                font-size: rem(14);
                margin-left: rem(16);
            }

            &::before {
                content: '';
                position: absolute;
                top: mrem(-1);
                left: mrem(-20);
                width: mrem(18);
                height: mrem(18);
                background: url('images/sms-check-block__retry-enter-icon.svg') no-repeat;
                background-size: mrem(18) mrem(18);

                @include on-desktop {
                    background-size: rem(16) rem(16);
                    width: rem(16);
                    height: rem(16);
                    top: rem(-1);
                    left: rem(0);
                }
            }
        }

        &__resend {
            cursor: pointer;
            position: relative;
            color: $blue;

            &::before {
                content: '';
                position: absolute;
                width: mrem(13);
                height: mrem(15);
                top: mrem(0);
                left: mrem(-20);
                background-size: mrem(13) mrem(15);
                background: url('images/sms-check-block__resend-icon.svg') no-repeat;

                @include on-desktop {
                    background-size: rem(12) rem(14);
                    width: rem(12);
                    height: rem(14);
                    top: rem(0);
                    left: rem(-20);
                }
            }
        }

        &__submit-button {
            margin-top: mrem(25);

            @include on-desktop {
                margin-top: rem(25);
            }
        }

        &__footer {
            position: relative;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            @include on-desktop {
                flex-direction: row;
                width: rem(374);
            }
        }

        &__wrong-code-msg {
            position: absolute;
            width: mrem(322);
            left: mrem(-50);
            top: mrem(-110);
            padding: mrem(18);
            text-align: center;
            border-radius: mrem(8);
            background: #fff;
            box-shadow: 0 mrem(3) mrem(22) rgba(0, 0, 0, 0.2), mrem(2) mrem(4) mrem(16) rgba(80, 97, 111, 0.23626);

            @include on-desktop {
                width: rem(322);
                left: rem(12);
                top: rem(-80);
                padding: rem(18);
                border-radius: rem(8);
                box-shadow: 0 rem(3) rem(22) rgba(0, 0, 0, 0.2), rem(2) rem(4) rem(16) rgba(80, 97, 111, 0.23626);
            }
        }

        &__wrong-code-btn {
            color: $blue;
        }

        &__wrong-code-text {
            margin: 0;
            font-size: mrem(14);

            @include on-desktop {
                font-size: rem(14);
            }
        }

        &__not-get-code {
            color: $blue;
            cursor: pointer;
            margin-bottom: 0;

            @include on-desktop {
                cursor: pointer;
                margin-bottom: rem(8);
            }
        }

        &__cancel {
            color: $blue;
            cursor: pointer;
        }
    }
</style>
